module.exports = __webpack_public_path__ + "img/favicon-efocus.46914497.png";